import { getCurrency } from '@common/utils/currency.ts'
import type { CellContext } from '@tanstack/react-table'

import { formatNumbersForSheet } from '@/utils/helpers'
import { getRandomNumber } from '@/utils/random'

import type { DetailedComparisonType } from '../../types'
import { detailedComparisonTableColumnTitles as titles } from './consts'

// to avoid id conflicts
const MIN_ID = 1000000000
const MAX_ID = 9999999999

export const getEmptyDetailedComparisonData = (): DetailedComparisonType => ({
  averageFanSpend: 0,
  creatorId: getRandomNumber(MIN_ID, MAX_ID),
  creator: 'Recently added creator',
  creatorUserName: 'Recently added creator user name',
  totalRevenue: 0,
  newSubs: 0,
  newSubscriptionsRevenue: 0,
  recurringSubscriptionsRevenue: 0,
  totalSubscriptionsRevenue: 0,
  tipsRevenue: 0,
  messageRevenue: 0,
  textingRatio: 0,
  linkClicks: 0,
  openChats: 0,
  sellingChats: 0,
  conversionRate: 0,
  spendingFansCount: 0,
})

export const getDetailedComparisonTableSheetData = (
  data: DetailedComparisonType[],
) =>
  data.map((item) => ({
    [titles.creator]: item.creator,
    [titles.creatorUserName]: item.creatorUserName,
    [titles.totalRevenue]: formatNumbersForSheet(item.totalRevenue),
    [titles.newSubs]: item.newSubs,
    [titles.newSubscriptionsRevenue]: formatNumbersForSheet(
      item.newSubscriptionsRevenue,
    ),
    [titles.recurringSubscriptionsRevenue]: formatNumbersForSheet(
      item.recurringSubscriptionsRevenue,
    ),
    [titles.tipsRevenue]: formatNumbersForSheet(item.tipsRevenue),
    [titles.messageRevenue]: formatNumbersForSheet(item.messageRevenue),
    [titles.textingRatio]: formatNumbersForSheet(item.textingRatio),
    [titles.openChats]: item.openChats,
    [titles.sellingChats]: item.sellingChats,
    [titles.averageFanSpend]: formatNumbersForSheet(item.averageFanSpend),
    [titles.linkClicks]: item.linkClicks,
    [titles.conversionRate]: formatNumbersForSheet(item.conversionRate),
  }))

export const detailedComparisonTableCellFormatter = (
  ctx: CellContext<DetailedComparisonType, unknown>,
  showCents?: boolean,
) => {
  switch (ctx.column.id as keyof typeof titles) {
    case 'totalRevenue':
    case 'newSubscriptionsRevenue':
    case 'recurringSubscriptionsRevenue':
    case 'tipsRevenue':
    case 'messageRevenue':
      return (value: string) => getCurrency(value, showCents ? 2 : 0)
    case 'averageFanSpend':
      return (value: string) => getCurrency(value ?? 0, 2)
  }
}
